
export default function useErrorCodeFromResponse(response) {
    if (!response || !response?.data?.error) {
        return null;
    }

    return response?.data?.error?.code;
}